<app-navbar (redirectToWelcome)="redirectToWelcome()"></app-navbar>

<div
  class="container flex-column justify-content-center align-items-center content-below-navbar"
>
  <div class="header-container">
    <div class="logo-grid">
      <!-- School Logo -->
      <div class="logo-section">
        <img
          [src]="
            schoolInfo()?.logo?.url ||
            schoolInfo()?.logo ||
            'https://assets.simpliedtech.com/logo_light'
          "
          alt="School Logo"
          class="logo-image"
          (error)="
            $event.target.src = 'https://assets.simpliedtech.com/logo_light'
          "
        />
        <h1 class="logo-text">{{ schoolInfo()?.name || 'School Name' }}</h1>
      </div>

      <!-- SimpliEd Logo -->
      <div class="logo-section simplied-section">
        <img
          src="https://assets.simpliedtech.com/logo_light"
          alt="SimpliEd Logo"
          class="logo-image"
        />
        <h1 class="logo-text">SimpliEd</h1>
      </div>
    </div>
  </div>

  <div class="row w-100 px-0 px-sm-2">
    <div class="col-12">
      <div class="dashboard-generic-box-white">
        <div class="card-content">
          <!-- Animated Icon -->
          <div class="icon-wrapper">
            <div class="icon-circle">
              <mat-icon class="lock-icon">lock</mat-icon>
            </div>
            <div class="icon-pulse"></div>
          </div>

          <!-- Heading -->
          <h2 class="card-heading">Admissions Closed</h2>

          <!-- Divider -->
          <div class="divider"></div>

          <!-- Messages -->
          <p class="card-text">
            Registration cannot be completed as admissions are currently closed
            for the selected branch and grade.
          </p>

          <p class="card-subtext">
            Please check back later or contact the school administration for
            more information.
          </p>

          <!-- Button -->
          <a class="btn round-button main-button" [href]="homeUrl">
            Back to Home
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
